/**
 * dashboard-anutel gira anche dentro un iframe del sito. L'HTML che arriva dal DB (articoli, aree
 * riservate, FAQ, convenzioni, testi delle iniziative) contiene link in formato `<a>` semplice, non
 * gestito dal router: un click ricarica l'intera pagina DENTRO l'iframe. Sia i link che escono
 * dall'app (es. "/articolo/N" e "/pagina/N" di sito-anutel, altre pagine di www.anutel.it) sia
 * quelli verso rotte di dashboard-anutel ("/utente/…") caricherebbero la shell del sito con il suo
 * iframe, annidando header e pagine all'infinito.
 * Questo hook DOMPurify globale imposta quindi `target="_blank"` (e `rel` con `noopener noreferrer`)
 * su tutti i link http/https. Restano invariati le ancore "#…", mailto:, tel: e qualunque schema
 * diverso da http/https. Un link che ha già `target="_blank"` resta com'è, con il solo `rel`
 * completato. `target` è impostato in `afterSanitizeAttributes`, dopo il filtro degli attributi,
 * quindi sopravvive anche dove la sanitize non ha `ADD_ATTR: LINK_TARGET_ATTR`; dompurifyLinks.js
 * lo accetta perché vale `_blank`. I link interni vengono riscritti da dompurifyAppLinks (prefisso
 * `PUBLIC_URL`) a prescindere dall'ordine di registrazione: l'hook non dipende dal loro href finale.
 * Se `PUBLIC_URL` è vuoto l'hook non si registra (no-op), come dompurifyAppLinks.
 * Da rimuovere quando sito-anutel sostituirà dashboard-anutel in produzione.
 */
import DOMPurify from 'dompurify';
import { APP_BASE } from './dompurifyAppLinks';

// true se l'href va aperto in una nuova scheda (qualunque http/https, tranne le ancore).
function apriInNuovaScheda(href) {
  const trimmed = typeof href === 'string' ? href.trim() : '';
  if (!trimmed || trimmed.startsWith('#')) return false;
  try {
    const { protocol } = new URL(trimmed, window.location.href);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}

if (APP_BASE && !DOMPurify.__anutelExternalNewTabHookRegistered) {
  DOMPurify.__anutelExternalNewTabHookRegistered = true;
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName !== 'A' || !node.hasAttribute('href')) return;
    if (!apriInNuovaScheda(node.getAttribute('href'))) return;

    node.setAttribute('target', '_blank');
    const relValues = (node.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (!relValues.includes('noopener')) relValues.push('noopener');
    if (!relValues.includes('noreferrer')) relValues.push('noreferrer');
    node.setAttribute('rel', relValues.join(' '));
  });
}
